import { render, staticRenderFns } from "./BenefitsContact.vue?vue&type=template&id=79c10415&scoped=true&"
import script from "./BenefitsContact.vue?vue&type=script&lang=js&"
export * from "./BenefitsContact.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsContact.vue?vue&type=style&index=0&id=79c10415&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c10415",
  null
  
)

export default component.exports